/**
 * Shared helpers for family-member display cards.
 *
 * Extracted from `FamilyMemberDisplayCard.tsx` so the component file only
 * exports React components (per the `react-refresh/only-export-components`
 * lint rule), keeping that file eligible for Fast Refresh.
 */

export function formatDobForDisplay(dob: string | null | undefined): string {
  const t = dob?.trim()
  if (!t) return '—'
  const m = t.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (m) return `${m[2]}/${m[3]}/${m[1]}`
  return t
}
